import { useState, useEffect } from 'react';
import { sliceCarouselCards, changeDirection, shouldChange } from 'utils/cards';
import { addCardholder } from '../cards';
import { ICard } from 'lib/type';

interface UseCardCarouselReturn {
    carouselCards: ICard[];
    currentCard: ICard;
    currentCardIndex: number;
    handleDirection: (clockwise: boolean) => void;
    handleCardClick: (position: 'left' | 'right' | 'center') => void;
    isStart: boolean;
    isEnd: boolean;
}

const useCardCarousel = (cards: ICard[]): UseCardCarouselReturn => {
    const [carouselCards, setCarouselCards] = useState<ICard[]>([]);
    const [currentCard, setCurrentCard] = useState<ICard>({} as ICard);
    const [currentCardIndex, setCurrentCardIndex] = useState<number>(0);
    const [isStart, setIsStart] = useState<boolean>(true);
    const [isEnd, setIsEnd] = useState<boolean>(false);

    const handleDirection = (clockwise: boolean): void => {
        setCurrentCardIndex(changeDirection(currentCardIndex, clockwise));
    };

    const handleCardClick = (position: 'left' | 'right' | 'center'): void => {
        if (
            (isStart && position === 'left') ||
            (isEnd && position === 'right')
        ) {
            return;
        }

        if (position === 'right') {
            setCurrentCardIndex(changeDirection(currentCardIndex, true));
        } else if (position === 'left') {
            setCurrentCardIndex(changeDirection(currentCardIndex, false));
        }
    };

    useEffect(() => {
        const updatedCards = addCardholder(cards) as ICard[];
        setCarouselCards(sliceCarouselCards(updatedCards, currentCardIndex));
        setCurrentCard(updatedCards[currentCardIndex]);
        setIsStart(shouldChange(updatedCards, currentCardIndex, false));
        setIsEnd(shouldChange(updatedCards, currentCardIndex, true));
    }, [currentCardIndex, cards]);

    return {
        carouselCards,
        currentCard,
        currentCardIndex,
        handleDirection,
        handleCardClick,
        isStart,
        isEnd,
    };
};

export default useCardCarousel;
